export default function IconWorkflow({
  color = 'currentColor',
  width = 24,
  height = 24,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3 1.5H9.5C9.89782 1.5 10.2792 1.65815 10.5605 1.93945C10.8419 2.22076 11 2.60218 11 3V9.5C11 9.89782 10.8419 10.2792 10.5605 10.5605C10.2792 10.8419 9.89782 11 9.5 11H6.5V15.5635C6.50026 16.6314 7.36849 17.5 8.43848 17.5H13V14.5C13 14.1022 13.1581 13.7208 13.4395 13.4395C13.6855 13.1934 14.0083 13.042 14.3516 13.0078L14.5 13H21C21.3978 13 21.7792 13.1581 22.0605 13.4395C22.3419 13.7208 22.5 14.1022 22.5 14.5V21C22.5 21.3978 22.3419 21.7792 22.0605 22.0605C21.7792 22.3419 21.3978 22.5 21 22.5H14.5C14.1022 22.5 13.7208 22.3419 13.4395 22.0605C13.1581 21.7792 13 21.3978 13 21V18H8.4375C7.79107 17.9996 7.17089 17.7423 6.71387 17.2852C6.25697 16.828 6.00022 16.2079 6 15.5615V11H3C2.60218 11 2.22076 10.8419 1.93945 10.5605C1.65815 10.2792 1.5 9.89782 1.5 9.5V3C1.5 2.60218 1.65815 2.22076 1.93945 1.93945C2.22076 1.65815 2.60218 1.5 3 1.5ZM14.5 13.5C14.2348 13.5 13.9805 13.6054 13.793 13.793C13.6054 13.9805 13.5 14.2348 13.5 14.5V21C13.5 21.2652 13.6054 21.5195 13.793 21.707C13.9805 21.8946 14.2348 22 14.5 22H21C21.2652 22 21.5195 21.8946 21.707 21.707C21.8946 21.5195 22 21.2652 22 21V14.5C22 14.2348 21.8946 13.9805 21.707 13.793C21.5195 13.6054 21.2652 13.5 21 13.5H14.5ZM3 2C2.73478 2 2.4805 2.10543 2.29297 2.29297C2.10543 2.4805 2 2.73478 2 3V9.5C2 9.76522 2.10543 10.0195 2.29297 10.207C2.48051 10.3946 2.73478 10.5 3 10.5H9.5C9.76522 10.5 10.0195 10.3946 10.207 10.207C10.3946 10.0195 10.5 9.76522 10.5 9.5V3C10.5 2.73478 10.3946 2.48051 10.207 2.29297C10.0195 2.10543 9.76522 2 9.5 2H3Z'
        fill={color}
        stroke={color}
      />
    </svg>
  );
}
